import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companyDetails: null,
  billingAddresses: null,
  fetchCompanyDetails: false,
  fetchingCountries: false,
  fetchingStates: false,
  fetchingCities: false,
  countries: [],
  states: [],
  cities: [],
  totalAddresses: [],
};

const companyBillingAddressSlice = createSlice({
  name: "companyBillingAddress",
  initialState,
  reducers: {
    fetchCompanyBillingAddress(state, action) {
      state.loading = true;
    },
    fetchCompanyBillingAddressSuccess(state, action) {
      state.billingAddresses = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyBillingAddressFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyDetails(state, action) {
      state.fetchCompanyDetails = true;
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.fetchCompanyDetails = false;
      state.companyDetails = action.payload.data.document;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.fetchCompanyDetails = false;
    },
    fetchTotalBillingAddresses(state, action) {
      state.loading = true;
    },
    fetchTotalBillingAddressesSuccess(state, action) {
      state.totalAddresses = action.payload.data.document;
      state.loading = false;
    },
    fetchTotalBillingAddressesFailure(state, action) {
      state.loading = false;
    },
    fetchCountries(state, action) {
      state.fetchingCountries = true;
    },
    fetchCountriesSuccess(state, action) {
      state.fetchingCountries = false;
      state.countries = action.payload.data.document;
    },
    fetchCountriesFailure(state, action) {
      state.fetchingCountries = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchCities(state, action) {
      state.fetchingCities = true;
    },
    fetchCitiesSuccess(state, action) {
      state.fetchingCities = false;
      state.cities = action.payload.data.document;
    },
    fetchCitiesFailure(state, action) {
      state.fetchingCities = false;
    },
    addBillingAddress(state, action) {
      state.loading = true;
      state.error = null;
    },
    addBillingAddressSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    addBillingAddressFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    updateBillingAddress(state, action) {
      state.loading = true;
      state.error = null;
    },
    updateBillingAddressSuccess(state, action) {
      state.error = null;
      state.loading = false;
    },
    updateBillingAddressFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.companyDetails = null;
      state.billingAddresses = null;
      state.fetchCompanyDetails = false;
      state.fetchingCountries = false;
      state.fetchingStates = false;
      state.fetchingCities = false;
      state.countries = [];
      state.states = [];
      state.cities = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyBillingAddressSlice;
